// Selector del periodo de datos con que se generan los reportes.
import { Input } from '@/kit';
import {
    REPORT_PERIOD_OPTIONS,
    type ReportPeriodPreset,
    type ReportPeriodSelection,
} from '../lib/reportPeriod';

const CONTROL =
    'rounded-[5px] border border-border bg-card px-2.5 py-1 text-[11.5px] font-semibold text-foreground focus:border-ring focus:outline-none';

export function ReportPeriodPicker({
    value,
    onChange,
}: {
    value: ReportPeriodSelection;
    onChange: (next: ReportPeriodSelection) => void;
}) {
    return (
        <div className="flex flex-wrap items-center gap-1.5 text-[10.5px] text-muted-foreground">
            <span>Periodo:</span>
            <select
                aria-label="Periodo"
                value={value.preset}
                onChange={(e) => {
                    onChange({ ...value, preset: e.target.value as ReportPeriodPreset });
                }}
                className={`cursor-pointer ${CONTROL}`}
            >
                {REPORT_PERIOD_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {value.preset === 'range' ? (
                <>
                    <Input
                        type="date"
                        aria-label="Desde"
                        className="h-7 w-auto px-2 text-[11px]"
                        value={value.fromDay ?? ''}
                        onChange={(e) => {
                            onChange({ ...value, fromDay: e.target.value || undefined });
                        }}
                    />
                    <Input
                        type="date"
                        aria-label="Hasta"
                        className="h-7 w-auto px-2 text-[11px]"
                        value={value.toDay ?? ''}
                        onChange={(e) => {
                            onChange({ ...value, toDay: e.target.value || undefined });
                        }}
                    />
                </>
            ) : null}
        </div>
    );
}
